//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
import { connect } from "react-redux";
// selection-scheduler imports
import { IProps, IContainer, IState } from "./ProfileWorkingPreferences.d";
import * as s from "./ProfileWorkingPreferences.styles";
// util
import { getCurrentWorkingGroup } from "@util/working-group.util";
import { timeSlots } from "@constants/time-slots.constant";
// state
import { IReduxState } from "@reducers/root.reducer";

//////////////////
// COMPONENT
//////////////////
class ProfileWorkingPreferencesComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderMeetingHours = () => {
    const { meetingHoursQueryResult } = this.props.org;
    const workingHours =
      meetingHoursQueryResult.userMeetingHours.edges.length > 0
        ? meetingHoursQueryResult.userMeetingHours.edges[0].node.workingHours
        : meetingHoursQueryResult.calendarMeetingHours.edges[0].node.workingHours;

    return workingHours.daySettings.map((daySetting, i) => {
      const { minSlot, maxSlot, excludedSlots } = daySetting.setting;
      const slotRanges = getSlotRangesFromSettings(({
        minSlot,
        maxSlot,
        excludedSlots,
        isOff: false,
      } as unknown) as DaySettingAttributes);

      return (
        <div key={i} style={s.workingHours.dayContainer}>
          <div style={s.workingHours.dayLabel}>{daySetting.day}:</div>
          <div>
            {slotRanges.map(({ startSlot, endSlot }) => (
              <div
                key={`working-pref-${daySetting.day[0]} ${startSlot}-${endSlot}`}
                style={s.stat.value}
              >
                {timeSlots.min[startSlot]} - {timeSlots.max[endSlot]}
              </div>
            ))}
          </div>
        </div>
      );
    });
  };

  private renderMostBookedRoom = () => {
    const { org } = this.props;
    const workingGroup = getCurrentWorkingGroup(org);
    const mostBookedRoom =
      workingGroup &&
      workingGroup.rooms.find((r) => r.roomId === org.summarizedWorkingPreferences.mostBookedRoom);

    if (!mostBookedRoom) {
      return <span />;
    }

    return (
      <div style={s.stat.container}>
        <div style={s.stat.label}>Top meeting location</div>
        <div style={s.stat.value}>{mostBookedRoom.name}</div>
      </div>
    );
  };

  public render() {
    const { org } = this.props;

    return (
      <div>
        <div style={s.workingHours.container}>
          <div style={s.stat.label}>Meeting hours</div>
          {this.renderMeetingHours()}
        </div>
        <div style={s.stat.container}>
          <div style={s.stat.label}>Busiest weekday</div>
          <div style={s.stat.value}>{org.summarizedWorkingPreferences.busiestDay}</div>
        </div>
        <div style={s.stat.container}>
          <div style={s.stat.label}>Best day for Focus Time</div>
          <div style={s.stat.value}>{org.summarizedWorkingPreferences.mostFocusTime}</div>
        </div>
        {this.renderMostBookedRoom()}
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const reduxContainer = connect(mapStateToProps, {})(ProfileWorkingPreferencesComponent);

//////////////////
// RELAY
//////////////////
import { fragments } from "./ProfileWorkingPreferences.gql";
import {
  DaySettingAttributes,
  getSlotRangesFromSettings,
} from "@clockwise/web-commons/src/ui/working-hours";
export const ProfileWorkingPreferences = createFragmentContainer<IContainer>(
  reduxContainer,
  fragments,
);
